import { useTranslation } from 'react-i18next'
import ListingTableHeader from '@/components/listings-table-header'
import { breakpoints } from '@/styles'
import useMediaQuery from '@/hooks/use-media-query'
import { FilterBar, FilterTextWrapper } from '@/components/search-filter'
import { TabMenu } from '@/components/tabs'

const MyTenantsHeader = ({ tabCount, currentTab, setCurrentTab, searchString, onSearch }) => {
  const { t } = useTranslation()
  const displayMobile = useMediaQuery(`(max-width: ${breakpoints.ipadMiniMax})`)
  const displayTablet = useMediaQuery(`(max-width: ${breakpoints.tabletLandscape})`)

  const menuItems = [
    {
      key: 'past',
      onClick: () => setCurrentTab('past'),
      isActive: currentTab === 'past',
      children: (
        <FilterTextWrapper>
          {t('l.tenants.list.past.button', 'Past')} <span>({tabCount.past})</span>
        </FilterTextWrapper>
      )
    },
    {
      key: 'current',
      onClick: () => setCurrentTab('current'),
      isActive: currentTab === 'current',
      children: (
        <FilterTextWrapper>
          {t('l.tenants.list.current.button', 'Current')} <span>({tabCount.current})</span>
        </FilterTextWrapper>
      )
    },
    {
      key: 'upcoming',
      onClick: () => setCurrentTab('upcoming'),
      isActive: currentTab === 'upcoming',
      children: (
        <FilterTextWrapper>
          {t('l.tenants.list.upcoming.button', 'Upcoming')} <span>({tabCount.upcoming})</span>
        </FilterTextWrapper>
      )
    }
  ]

  return (
    <ListingTableHeader
      title={t('l.tenants.list.rented.title', 'Rented')}
      searchString={searchString}
      onSearch={onSearch}
      height={displayTablet ? 110 : undefined}
    >
      <FilterBar>
        <TabMenu
          options={menuItems}
          theme={displayMobile ? 'primary' : 'secondary'}
          size="medium"
          height={displayMobile && 44}
        />
      </FilterBar>
    </ListingTableHeader>
  )
}

export default MyTenantsHeader
